__turbopack_context__.v({
  "announcement": "InfoBar-module__JLOBFq__announcement",
  "bar": "InfoBar-module__JLOBFq__bar",
  "divider": "InfoBar-module__JLOBFq__divider",
  "dotClosed": "InfoBar-module__JLOBFq__dotClosed",
  "dotOpen": "InfoBar-module__JLOBFq__dotOpen",
  "item": "InfoBar-module__JLOBFq__item",
  "kicker": "InfoBar-module__JLOBFq__kicker",
  "reserve": "InfoBar-module__JLOBFq__reserve",
  "value": "InfoBar-module__JLOBFq__value",
  "valueLink": "InfoBar-module__JLOBFq__valueLink",
  "wrap": "InfoBar-module__JLOBFq__wrap",
});
